export const GET_QUOTE_FORM = (categoryId: string) => `quoterequest/getform/${categoryId}`;

export const PATCH_QUOTE_FORM = (id: number) => `quoteRequest/updateQuoteForm/${id}`;

export const UPLOAD_FILE = `/quoteRequest/fileupload`;
